import React from 'react';
import styled from 'styled-components';
import images from 'rc-images';

const Container = styled.div`
  margin: 20px 0;
`;

const Email = styled.div`
  all: initial;
  padding: 10px 0;
  padding-left: 30px;
  position: relative;
  font-size: 15px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  display: block;
  color: #404040 !important;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-image: url(${images.icons.email});
    width: 20px;
    height: 20px;
    background-size: 20px;
    background-repeat: no-repeat;
  }
`;

const Phone = styled.div`
  all: initial;
  padding: 10px 0;
  padding-left: 30px;
  position: relative;
  font-size: 15px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  display: block;
  color: #404040 !important;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-image: url(${images.icons.phone});
    width: 20px;
    height: 20px;
    background-size: 20px;
    background-repeat: no-repeat;
  }
`;

const Contact = ({ email, phone }) => (
  <Container>
    {
      email
      && email !== 'null'
        ? (
          <Email>
            {email}
          </Email>
        ) : null
    }
    {
      phone
      && phone !== 'null'
        ? (
          <Phone>
            {phone}
          </Phone>
        ) : null
    }
  </Container>
);

export default Contact;
